/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SearchResult} from 'common/report/util/search/types';
import {CreatorWithViewsIcon} from 'common/widgets/user-list/presets';

export const BrowseCreatorWithViews = ({entity}: {entity: SearchResult}) => {
  return (
    <CreatorWithViewsIcon
      entityCreator={{
        id: entity.user_id,
        name: entity.user,
        email: entity.email,
        date: entity.created,
      }}
      entityEditor={{
        id: entity.last_modified_by_id,
        name: entity.last_modified_by_name,
        email: entity.last_modified_by_email,
        date: entity.last_edited,
      }}
      presenceViews={(entity.presence_views || []).map(({user, timestamp}) => {
        return {
          id: user.id,
          email: user.email,
          name: user.name,
          lastViewedUtcSeconds: timestamp,
        };
      })}
      totalPresenceViews={entity.unique_count}
    />
  );
};
